/**
 * Server-rendered SEO content — removal on boot.
 *
 * inc/seo-content.php ships a real, readable summary of the page inside
 * <main id="v2-app"> so crawlers that do not run JavaScript (GPTBot,
 * ClaudeBot, PerplexityBot, Bingbot — and so DuckDuckGo, which serves Bing's
 * index) have something to index and quote. The app then paints the same page
 * properly, and that block has to go.
 *
 * Most views open with `el.innerHTML = …`, which would clear it anyway. This
 * is the guarantee that does not depend on every view remembering to: the
 * router calls it before each mount, and it targets the block by its own
 * attribute so it can never take app content with it.
 */

/** Matches the attribute inc/seo-content.php stamps on the block. */
const SSR_SELECTOR = '[data-ssr-seo]';

/**
 * Remove any server-rendered SEO block inside `root` (and the style tag that
 * only existed for it). Safe to call repeatedly — after the first boot there
 * is nothing left to find.
 */
export function clearServerContent(root) {
  if (!root) return;
  root.querySelectorAll?.(SSR_SELECTOR).forEach((node) => node.remove());
  document.getElementById('yoink-seo-style')?.remove();
}
